import React, {Component} from 'react';
import {Card, Button, Grid} from 'semantic-ui-react';

class ObsolescencePageHeader extends Component {
  render() {
    const {saveButtonDisabled} = this.props;
    return (
      <Card raised fluid>
        <Grid.Row>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento de parámetros de obsolescencia</h2>
              <div className='title-bar-actions'>
                <Button primary
                  disabled={saveButtonDisabled}
                  onClick={this.props.handleSaveClick}
                >
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        </Grid.Row>
      </Card>
    );
  }
}

export default ObsolescencePageHeader;
